import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';
import { DrawApi } from '@apply/api';
import { DrawType } from '@apply/constants';
import { AddDrawCard } from './components/AddDrawCard';
import { PendingDrawCard } from './components/PendingDrawCard';
import { BlockedDrawCard } from './components/BlockedDrawCard';
import { ResignDrawCard } from './components/ResignDrawCard';
import { ContinueDrawCard } from './components/ContinueDrawCard';
import { useDenyGCAccessIfUnauthorized } from '../../../../../../draws_v2/functions/gcDrawAuthorization';
import { useAuthentication } from '../../../../../../Login/hooks/useAuthentication';

interface LoanDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}
export const LoanDrawCard: React.FC<LoanDrawCardProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    const { authentication } = useAuthentication();
    const { isGeneralContractor } = authentication?.user || {};

    const Card = () => {
        const {
            canAddDraw,
            isApproved,
            isEquityMet,
            isBudgetMaxed,
            borrowerSubmitted,
            needsBorrowerSignature,
            latestDrawType,
            generalContractorSignatureId,
        } = dashboardDrawBudget;
        const denyGCAccess = useDenyGCAccessIfUnauthorized(dashboardDrawBudget.canGCAddDraw);
        if (denyGCAccess) {
            return <BlockedDrawCard dashboardDrawBudget={dashboardDrawBudget} />;
        }

        if (canAddDraw) {
            return (
                <AddDrawCard
                    dashboardDrawBudget={dashboardDrawBudget}
                    set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                />
            );
        }

        const gcSubmitted = isGeneralContractor && generalContractorSignatureId;
        if (latestDrawType == DrawType.Manual && !borrowerSubmitted && !gcSubmitted) {
            return <ContinueDrawCard dashboardDrawBudget={dashboardDrawBudget} />;
        }

        if (borrowerSubmitted && needsBorrowerSignature) {
            return <ResignDrawCard dashboardDrawBudget={dashboardDrawBudget} />;
        }

        if (!isApproved || !isEquityMet || isBudgetMaxed) {
            return <BlockedDrawCard dashboardDrawBudget={dashboardDrawBudget} />;
        }

        return (
            <PendingDrawCard
                dashboardDrawBudget={dashboardDrawBudget}
                set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
            />
        );
    };
    return (
        <Panel
            key={dashboardDrawBudget.loanId}
            theme={PanelTheme.White}
            borderStyle={PanelBorderStyle.Solid}
            borderRadius={PanelBorderRadius.Small}
            padding={16}
        >
            <Card />
        </Panel>
    );
};
